export const attachmentChipStatuses = Object.freeze({
  pending: 'yellow',
  approved: 'green',
  rejected: 'red',
  pending_upload: 'yellow',
  expired: 'yellow',
  not_applicable: 'gray',
  about_to_expire: 'yellow'
})
